import React from 'react';
import '@google/model-viewer';
import { createRoot } from 'react-dom/client';
import { NotificationContainer } from 'react-notifications';

import Router from './router';
import './style/index.scss';

import './utils/i18n';

class App extends React.Component {
  render() {
    return (
      <>
        <Router />
        <NotificationContainer />
      </>
    );
  }
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
